import { cn } from "@/lib/cn";
import { forwardRef } from "react";
import Icon from "../Icon/Icon";
import type { IconName } from "../Icon/iconMap";
import { Button, buttonVariants } from "../ui/button";

export default forwardRef<
  HTMLDivElement,
  JSX.IntrinsicElements["div"] & {
    iconName?: IconName;
    onClear?: () => void;
  }
>(function AppliedFilterChip(props, ref) {
  const { children, className, iconName, onClear, ...rest } = props;

  return (
    <div
      ref={ref}
      className={cn(
        buttonVariants({ variant: "outline", size: "sm" }),
        "gap-2 bg-primary-muted-fill",
        className,
      )}
      {...rest}
    >
      {iconName && <Icon iconName={iconName} />}
      {children}
      <Button
        variant="ghost"
        size="icon"
        onClick={onClear}
        className="size-fit"
      >
        <Icon iconName="XIcon" />
      </Button>
    </div>
  );
});
